<template>
  <div>
    <Hero />
    <div class="tabs-container">
      <Tab v-on:click="onTabSelected(1)" tabName="Йога онлайн" title="left"
           v-bind:selected="isTabSelected(1)">
      </Tab>
      <Tab v-on:click="onTabSelected(2)" tabName="Курсы" title="right"
           v-bind:selected="isTabSelected(2)">
      </Tab>
    </div>
    <div class="container is-fluid mt-6">
      <template v-if="selectedTab === 1">
        <YogaOnlineContent/>
      </template>
      <template v-if="selectedTab === 2">
        <MarathonsContent/>
      </template>
    </div>
    <div class="section container is-fluid blue-block">
      <Teachers/>
    </div>
  </div>

</template>

<script>
import Hero from "../components/Hero";
import Tab from '../components/Tab'
import YogaOnlineContent from './YogaOnlineContent'
import MarathonsContent from './MarathonsContent'
import Teachers from "../components/Teachers";

export default {
  name: 'App',
  data() {
    return {
      selectedTab: 1,
    }
  },
  methods: {
    onTabSelected: function (tabId) {
      this.selectedTab = tabId;
    },
    isTabSelected: function (tabId) {
      return tabId === this.selectedTab
    },
  },
  components: {
    Teachers,
    Hero,
    Tab,
    YogaOnlineContent,
    MarathonsContent
  }
}
</script>

<style>

.blue-block {
  background-color: #f4f7fb;
}

.tabs-container {
  background-image: linear-gradient(#f2ced2, white);
}
</style>
